import { css, DefaultTheme } from 'styled-components';
import { memoizeFunction } from '@agilepoint/utils-common';
import { MenuType } from '../theme';

export const getCommonMenuStyle = memoizeFunction((type: MenuType) => {
    const getMenuThemeByType = (theme: DefaultTheme) => theme.menu[type];
    return css`
        position: relative;
        box-sizing: border-box;
        user-select: none;
        border-style: solid;
        overflow: hidden;
        background-color: ${({ theme }) => getMenuThemeByType(theme).colors.backgroundColor};
        border-color: ${({ theme }) => getMenuThemeByType(theme).colors.borderColor};
        border-width: ${({ theme }) => getMenuThemeByType(theme).composites.borderWidth.root};
        border-radius: ${({ theme }) => getMenuThemeByType(theme).composites.borderRadius.root};
    `;
});
